<template>
  <div class="container">
    <h4 class="title">{{ $t("new order") }}</h4>
    <div class="columns">
      <div class="column is-three-fifths">
        <product-selector ref="product_selector" @dish-selected="add_dish" />
      </div>
      <div class="column">
        <order-emitter ref="order_emitter"></order-emitter>
      </div>
    </div>
  </div>
</template>

<script>
import ProductSelector from "./product_selector/Index.vue";
import OrderEmitter from "./order_emitter/Index.vue";

export default {
  name: "RestaurantOrderIndex",
  components: { ProductSelector, OrderEmitter },
  data() {
    return {};
  },
  methods: {
    add_dish(dish) {
      this.$refs.order_emitter.set_plate(dish);
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
